export class ProductBoostRange {
  constructor(minDate, maxDate) {
    this.minDate = minDate || null;
    this.maxDate = maxDate || null;
  }

  static toInstance(props = {}) {
    return new ProductBoostRange(props.min_date, props.max_date);
  }
}
